import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { whatsAppSimple } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/images";

export const Membership = () => {
  const { t } = useI18n();
  return (
    <section className="py-28 md:py-40 border-b border-vm-border" data-testid="membership-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="overflow-hidden">
            <img src={IMAGES.membership} alt={t("membership.title")} loading="lazy" className="w-full h-[380px] md:h-[520px] object-cover hover:scale-105 transition-transform duration-[1200ms]" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="vm-label mb-5">{t("membership.label")}</p>
          <h2 className="font-serif font-light leading-[1.02] text-3xl md:text-5xl mb-8">{t("membership.title")}</h2>
          <p className="text-vm-text2 font-light leading-relaxed max-w-lg mb-10">{t("membership.body")}</p>
          <a href={whatsAppSimple()} target="_blank" rel="noopener noreferrer" className="vm-btn-ghost inline-flex px-8 py-3.5 text-xs tracking-[0.2em] uppercase" data-testid="membership-cta">
            {t("membership.cta")}
          </a>
        </Reveal>
      </div>
    </section>
  );
};
